/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS number / date formatting — the one copy of the reference app's
   lib/dashboardFormat.tsx, shared by every GrowthOS page so a value never
   renders differently from one page to the next.
   ──────────────────────────────────────────────────────────────────────────── */
import React from 'react'
import { GX_NEGATIVE, GX_POSITIVE } from './GrowthOsUi'

const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** '2026-09' → 'Sep 26' ('' when missing). */
export const monthLabel = (ym) => {
  if (!ym) return ''
  const [y, m] = ym.split('-').map(Number)
  return `${MON[m - 1]} ${String(y).slice(2)}`
}
/** '2026-09-30' → 'Sep 30, 2026' ('—' when missing). */
export const shortDate = (iso) => (iso
  ? new Date(`${iso}T00:00:00Z`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
  : '—')
export const integer = (v) => (v === null || v === undefined ? '—' : Number(v).toLocaleString('en-IN'))
export const currency = (v) => (v === null || v === undefined ? '—' : `₹${Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`)
export const percentage = (v) => (v === null || v === undefined ? '—' : `${Number(v).toFixed(1)}%`)
export const compactCurrency = (v) => `₹${Intl.NumberFormat('en-IN', { notation: 'compact', maximumFractionDigits: 1 }).format(Number(v || 0))}`
export const daysAgoLabel = (days) => {
  if (days === null || days === undefined) return 'Never'
  if (days <= 0) return 'Today'
  if (days === 1) return '1 day ago'
  return `${Math.round(days)} days ago`
}

/** KPI sub-line: "Previous: ₹X · ↑ 3.2%" ('' when there is no metric). */
export function comparison(m, fmt) {
  if (!m) return ''
  const prev = fmt(m.previous)
  if (m.changePct === null || m.changePct === undefined) return `Previous: ${prev}`
  return `Previous: ${prev} · ${m.changePct >= 0 ? '↑' : '↓'} ${Math.abs(m.changePct).toFixed(1)}%`
}

/** Green ↑ / red ↓ growth percentage, muted '—' when unknown. */
export function GrowthPct({ pct }) {
  if (pct === null || pct === undefined) return <span style={{ color: '#94a3b8' }}>—</span>
  const up = pct >= 0
  return <span style={{ color: up ? GX_POSITIVE : GX_NEGATIVE }}>{up ? '↑' : '↓'} {Math.abs(pct).toFixed(1)}%</span>
}
